import { WatchTowerParameterType } from 'utils/apiList/fraudWatchTower'

export type ShowModalType = '' | 'MODAL_CREATE' | 'MODAL_EDIT'
export type WatchtowerStatusType = 'INACTIVE' | 'ACTIVE'
export type RuleType = 'INCLUDE' | 'EXCLUDE'
export type LogicType = 'AND' | 'OR'
export type { WatchTowerParameterType }

export type GroupParameterRuleValueType = {
  id: number
  value: string
  is_deleted: boolean
}

export type GroupParameterRuleType = {
  id: number
  operator: string
  parameter_id: number
  values: GroupParameterRuleValueType[]
  composedValue: string
  logic: LogicType
  selectedParameter: WatchTowerParameterType | null
  uniqueParameterId: string
  is_deleted: boolean
}

export type WatchtowerModeType = 'WATCHTOWER' | 'AUTO_CANCELLATION'

export type GroupRuleType = {
  id: number
  rule_type: RuleType
  uniqueGroupId: string
  logic: LogicType
  parameter_rules: GroupParameterRuleType[]
  is_deleted: boolean
}

export type FormRuleDetailType = {
  id: number
  name: string
  flag_device_score: boolean
  device_score: number
  flag_activity_score: boolean
  activity_score: number
  status: WatchtowerStatusType
  group_rules: GroupRuleType[]
  group_rules_include: GroupRuleType[]
  group_rules_exclude: GroupRuleType[]
  start_date: string
  start_time: string
  end_date: string
  end_time: string
  type: WatchtowerModeType
}

export type QueryType = {
  page_index: number
  page_size: number
  name: string
  status: string
}

export type WatchtowerFilterStateType = {
  fetchDataState: 'INITIAL' | 'LOADING' | 'SUCCESS' | 'ERROR'
  form: WatchtowerConfigType
  isModalOpen: boolean
}

export type WatchtowerRuleV2StateType = {
  isLoading: boolean
  query: QueryType
  ruleList: GetWatchTowerRuleV3ResponseType['rules']
  showModal: ShowModalType
  formRuleDetail: FormRuleDetailType
  parameterList: WatchTowerParameterType[]
  isEditPriorityMode: boolean
  watchtowerFilter: WatchtowerFilterStateType
}

export type SetQueryPayloadActionType = {
  value: Partial<QueryType>
}
export type SetShowModalPayloadActionType = { value: ShowModalType }
export type SetFormRuleDetailPayloadActionType = {
  value: FormRuleDetailType[keyof FormRuleDetailType]
  name: keyof FormRuleDetailType
}
export type SetGroupRulePayloadActionType = {
  value: RuleType
  action: 'ADD' | 'REMOVE'
}
export type AddRemoveGroupParameterRulePayloadActionType = {
  value: RuleType
  action: 'ADD' | 'REMOVE'
  groupIndex: number
  parameterIndex?: number
}

export type SetGroupParameterRulePayloadActionType = {
  ruleType: RuleType
  groupIndex: number
  parameterIndex: number
  value: Partial<GroupParameterRuleType>
}

export type GetWatchTowerRuleV3RequestType = {
  params: {
    page_index: number
    page_size: number
    status: string
    type: WatchtowerModeType
    sort?: string
    direction?: string
  }
}
export type GetWatchTowerRuleV3ResponseType = {
  rules: {
    updated_at: string
    created_at: string
    created_by: string
    id: number
    updated_by: string
    name: string
    flag_device_score: boolean
    device_score: number
    flag_activity_score: boolean
    activity_score: number
    status: WatchtowerStatusType
    start_date: string
    end_date: string
    status_string: string
    priority: number
  }[]
}

export type PutWatchtowerStatusRequestType = {
  id: string
  payload: {
    status: WatchtowerStatusType
  }
}

export type GetWatchTowerRuleV3DetailRequestType = {
  id: string
}

export type GetWatchTowerRuleV3DetailResponseType = {
  rule: {
    id: number
    name: string
    flag_device_score: boolean
    device_score: number
    flag_activity_score: boolean
    activity_score: number
    status: WatchtowerStatusType
    type: WatchtowerModeType
    group_rules: {
      id: number
      is_deleted: boolean
      rule_type: RuleType
      logic: LogicType
      parameter_rules: {
        id: number
        operator: string
        parameter_id: number
        is_deleted: boolean
        values: {
          id: number
          value: string
          is_deleted: boolean
        }[]
        logic: LogicType
      }[]
    }[]
    start_date: number
    end_date: number
  }
}

export type PostWatchtowerRuleRequestType = {
  payload: {
    name: string
    flag_device_score: boolean
    device_score: number
    flag_activity_score: boolean
    activity_score: number
    type: WatchtowerModeType
    group_rules: {
      rule_type: RuleType
      parameter_rules: {
        operator: string
        parameter_id: number
        values: string[]
        is_deleted: boolean
      }[]
    }[]
    start_date: number
    end_date: number
  }
}

export type ParameterRuleValueType = { id: number; value: string; is_deleted: boolean }

export type PutWatchtowerRuleRequestType = {
  payload: {
    name: string
    flag_device_score: boolean
    device_score: number
    flag_activity_score: boolean
    activity_score: number
    type: WatchtowerModeType
    group_rules: {
      rule_type: RuleType
      id: number
      is_deleted: boolean
      parameter_rules: {
        id: number
        operator: string
        parameter_id: number
        values: ParameterRuleValueType[]
        is_deleted: boolean
      }[]
    }[]
    start_date: number
    end_date: number
  }
  id: string
}

export enum WatchtowerFilterActivationEnum {
  ACTIVE = 'ACTIVE',
  INACTIVE = 'INACTIVE',
}

export type WatchtowerConfigType = {
  filter_bypass_in_review: WatchtowerFilterActivationEnum
  filter_watch_tower: WatchtowerFilterActivationEnum
  filter_new_buyer: WatchtowerFilterActivationEnum
}

export type SetWatchtowerFilterFormPayloadType = {
  field: keyof WatchtowerConfigType
  value: WatchtowerConfigType[keyof WatchtowerConfigType]
}
